<template>
  <div class="central_content">
    <div style="display: flex; flex-wrap: wrap">
      <div class="search_list">
        <div class="text">按时间筛选:</div>
        <DatePicker
          type="daterange"
          placement="bottom-end"
          @on-change="getData"
          class="select"
        ></DatePicker>
      </div>
    </div>

    <Table
      class="table_style"
      border
      :columns="columns"
      :data="userList.list"
      :highlight-row="true"
    >
      <template slot-scope="{ row, index }" slot="userType">
        <div v-if="row.userType == 1">vip</div>
        <div v-if="row.userType == 2">团长</div>
        <div v-if="row.userType == 3">运营商</div>
      </template>
      <template slot-scope="{ row, index }" slot="userIdentity">
        <div v-if="row.userIdentity == 0">合伙人</div>
        <div v-if="row.userIdentity == 1">普通用户</div>
      </template>
      <template slot-scope="{ row, index }" slot="type">
        <div v-if="row.type == 0">直推</div>
        <div v-if="row.type == 1">下级</div>
        <div v-if="row.type == 2">自己</div>
      </template>
      <template slot-scope="{ row, index }" slot="channel">
        <div v-if="row.channel == 1">肯德基</div>
        <div v-if="row.channel == 2">云油</div>
        <div v-if="row.channel == 3">电影票</div>
        <div v-if="row.channel == 4">团油</div>
        <div v-if="row.channel == 5">青桔</div>
        <div v-if="row.channel == 6">淘油宝</div>
        <div v-if="row.channel == 7">洗车</div>
        <div v-if="row.channel == 8">话费充值</div>
        <div v-if="row.channel == 9">星巴克代点</div>
        <div v-if="row.channel == 10">星巴克卡券</div>
        <div v-if="row.channel == 11">商城</div>
        <div v-if="row.channel == 12">油卡充值</div>
        <div v-if="row.channel == 13">音视频充值奖励</div>
        <div v-if="row.channel == 14">电费充值</div>
        <div v-if="row.channel == 15">激活奖励</div>
        <div v-if="row.channel == 16">美团外卖</div>
        <div v-if="row.channel == 17">提现佣金</div>
        <div v-if="row.channel == 18">美团联盟</div>
        <div v-if="row.channel == 19">优惠金充值奖励</div>
        <div v-if="row.channel == 20">返佣产品</div>
        <div v-if="row.channel == 21">购卡奖励</div>
        <div v-if="row.channel == 22">滴滴奖励</div>
      </template>
    </Table>

    <Page :total="userList.total" @on-change="switchover" />
  </div>
</template>

<script>
import { api } from "../biz/api";
export default {
  name: "home",
  data() {
    return {
      parameter: {
        pageNow: 1,
        type: "",
        keyword: "",
        startTime: "",
        endTime: "",
        channel: "",
      },
      userList: { list: [] },
      upData: {},
      showConfig: false,
      columns: [
        {
          title: "用户手机号",
          className: "fontcolor",
          align: "center",
          key: "userPhone",
        },
        {
          title: "名称",
          className: "fontcolor",
          align: "center",
          key: "title",
        },
        {
          title: "账户类型",
          className: "fontcolor",
          align: "center",
          slot: "userType",
        },
        {
          title: "账号身份",
          className: "fontcolor",
          align: "center",
          slot: "userIdentity",
        },
        {
          title: "奖励来源",
          className: "fontcolor",
          align: "center",
          slot: "type",
        },
        {
          title: "来源用户",
          className: "fontcolor",
          align: "center",
          key: "originUserPhone",
        },
        {
          title: "业务渠道",
          className: "fontcolor",
          align: "center",
          slot: "channel",
        },
        {
          title: "金额",
          className: "fontcolor",
          align: "center",
          key: "amount",
        },
        {
          title: "创建时间",
          className: "fontcolor",
          align: "center",
          key: "createTime",
        },

        {
          title: "id",
          className: "fontcolor",
          align: "center",
          key: "id",
        },

        {
          title: "订单号",
          className: "fontcolor",
          align: "center",
          key: "orderNo",
        },
      ],
    };
  },
  mounted: function () {
    this.getData();
  },
  methods: {
    switchover(pageNow) {
      this.parameter.pageNow = pageNow;
      this.getData();
    },

    getData(a) {
      if (a) {
        this.parameter.startTime = a[0];
        this.parameter.endTime = a[1];
      }
      api.TeamStatistics(this.parameter).then((res) => {
        this.userList = res.body.data;
      });
    },
  },
};
</script>

<style scoped>
</style>